import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const EducationContainer = styled.div `
  margin-bottom: 40px;
`;
const EducationTitle = styled.h3 `
  font-size: 1.7em;
  margin-bottom: 30px;
  color: #22334a;
`;
const EducationCard = styled.div `
  background: linear-gradient(120deg, #fffdf4 0%, #fff 100%);
  border: 2px solid #ffce3c;
  border-radius: 16px;
  padding: 24px 28px;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(255,206,60,0.07);
`;
const EducationInstitution = styled.h4 `
  font-size: 1.25rem;
  font-weight: 700;
  color: #22334a;
  margin: 0 0 8px 0;
  line-height: 1.3;
`;
const EducationDate = styled.p `
  font-size: 1.1rem;
  font-weight: 600;
  color: #22334a;
  opacity: 0.8;
  margin: 0 0 8px 0;
`;
const EducationLocation = styled.p `
  font-size: 1rem;
  color: #888;
  margin-bottom: 0.3rem;
  margin-top: 0;
`;
const EducationDegree = styled.p `
  font-size: 1.05rem;
  color: #444;
  margin: 12px 0 0 0;
  line-height: 1.4;
`;
const Education = () => {
    return (_jsxs(EducationContainer, { children: [_jsx(EducationTitle, { children: "Education" }), _jsxs(EducationCard, { children: [_jsxs(EducationInstitution, { children: ["Indian Institute of Technology ", _jsx("br", {}), "(Indian School of Mines) Dhanbad"] }), _jsx(EducationDate, { children: "2014 \u2013 2018" }), _jsx(EducationLocation, { children: "Jharkhand, India - 826004" }), _jsxs(EducationDegree, { children: ["B. Tech in Electrical Engineering, ", _jsx("br", {}), "Minors in Computer Science and Engineering."] })] })] }));
};
export default Education;
